//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'));

export default {
  name: 'Contactgegevens',
  props: {
    errors: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    inBuitenland: false,
  }),
  computed: {
    countries() {
      const list = countries.getNames('nl', {select: 'official'});
      return Object.keys(list).map(key => ({value: key, label: list[key]}));
    },
  },
  methods: {
    getAddress() {
      if (!this.inBuitenland) {
        this.$emit('getAddress');
      }
    },
  },
};
